import { GetterTree } from 'vuex'

import { RootState } from '@/store/types'

import { PaymentState } from './types'

const getters: GetterTree<PaymentState, RootState> = {
  getPayment: state => state.paymentPageData,

  isPaymentFilled: state => {
    if (
      state.paymentPageData.firstName &&
      state.paymentPageData.lastName &&
      state.paymentPageData.street &&
      state.paymentPageData.houseNumber &&
      state.paymentPageData.postcode &&
      state.paymentPageData.city
    ) {
      return true
    }

    return false
  },
}

export default getters
